import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  UrlTree
} from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class RoleGuard implements CanActivate {

  constructor(private auth: AuthService, private router: Router) { }

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    const allowedRoles: string[] = route.data['roles'] ?? [];

    // Public route
    if (allowedRoles.includes('*')) return true;

    // Ensure we know who the user is (cookie sent by interceptor)
    const me = await this.auth.getCurrentUser();

    // Not authenticated → go to login
    if (!me) {
      return this.router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
    }

    // No role restriction → allow
    if (allowedRoles.length === 0) return true;

    // Check for any overlap
    const userRoles = me.roles ?? [];
    const hasAccess = userRoles.some(r => allowedRoles.includes(r));

    if (!hasAccess) {
      console.warn(`[RoleGuard] Access denied to ${state.url}. Required: ${allowedRoles.join(', ')} | User: ${userRoles.join(', ')}`);
      return this.router.parseUrl('/access-denied');
    }

    return true;
  }
}
